<template>
	<div class="ticket-book-notice-box">
		<div class="close-layer" @click="close"></div>
		<div class="ticket-bnb-content">
			<i class="iconfont icon-close" @click="close"></i>
			<div class="ticket-bnbt-head">预订须知</div>
			<div class="ticket-bnbt-info">
				<div class="ticket-bi-item">
					<span>预定说明</span>
					<div>
						<p>有效期：{{info.EffectiveDesc||'无'}}</p>
					</div>
				</div>
				<div class="ticket-bi-item">
					<span>费用说明</span>
					<div>
						<p>费用包含：{{info.CostInclude||'无'}}</p>
						<p>费用不包含：{{info.CostNoinclude||'无'}}</p>
					</div>
				</div>
				<div class="ticket-bi-item">
					<span>入园须知</span>
					<div>
						<p>入园时间：{{info.LimitTime||'无'}}</p>
						<p>入园地点：{{info.VisitAddress||'无'}}</p>
						<p>取票时间：{{info.PickupTime||'无'}}</p>
						<p>取票地点：{{info.NeedPickup?(info.PickupAddr||'无'):'无'}}</p>
						<p>入园方式：{{info.NoticeWays||'无'}}</p>
					</div>
				</div>
				<div class="ticket-bi-item">
					<span>退改规则</span>
					<div>
						<p>{{info.RegressionRule||'无'}}</p>
					</div>
				</div>
				<div class="ticket-bi-item">
					<span>重要提示</span>
					<div>
						<p>票种说明：{{info.TicketDesc||'无'}}</p>
						<p>重要提示：{{info.ImportantNotice||'无'}}</p>
					</div>
					
				</div>

			</div>
		</div>
	</div>	
</template>
<script>
	import Rull from './rull.vue'//安全需知
	export default{
		name:'ticket-notice',
		components:{
			Rull
		},
		props:{
			info:{
				type:Object,
				default:()=>{
					return {}
				}
			}
		},
		data(){
			return{
				isRullShow:false
			}
		},
		methods:{
			close(){
				this.$emit('close')
			}

		}
	}
</script>




// WEBPACK FOOTER //
// src/components/ticket/bookNotice/bookNotice.vue